// extracted by mini-css-extract-plugin
export var chevron = "_jg-2";
export var dropdownItems = "_jg-0";
export var item = "_jg-1";